import { inject } from '@angular/core';
import { CanActivateFn, createUrlTreeFromSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IAppState } from '../../../app/app.reducer';
import { selectUserType } from '../../app-configuration/app-configuration.reducer';
import { UserType } from '../../app-configuration/models/UserType';

export const isFreightPayerGuard: CanActivateFn = (route, state) => {
  const store$ = inject(Store<IAppState>);

  return new Observable<boolean | UrlTree>((observer) => {
    store$.select(selectUserType).subscribe((userType) => {
      if (userType === UserType.FreightPayer) {
        observer.next(true);
        observer.complete();
      } else {
        observer.next(createUrlTreeFromSnapshot(route, ['/']));
        observer.complete();
      }
    });
  });
};
